import {Injectable, Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'telefoneMask'
})
@Injectable({
  providedIn: 'root'
})
export class TelefonePipe implements PipeTransform {
  transform(telefone: string): string {
    if (!telefone) return '';

    const numero = telefone.replace(/\D/g, '');

    if (numero.length === 11) {
      return numero.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    } else if (numero.length === 10) {
      return numero.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    }

    return telefone;
  }
}
